module.exports = __webpack_public_path__ + "img/rgb_ai_55.jpg";